import React from "react";
import { Box, Skeleton } from "@mui/material";
import { NJIM } from "../../theme/njimTheme";

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
}

const TableSkeleton: React.FC<TableSkeletonProps> = ({
  rows = 6,
  columns = 5,
}) => {
  return (
    <Box
      sx={{
        border: `1px solid ${NJIM.border}`,
        borderRadius: "12px",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
          gap: 2,
          px: 2,
          py: 1.5,
          bgcolor: NJIM.muted,
        }}
      >
        {Array.from({ length: columns }).map((_, i) => (
          <Skeleton key={`h-${i}`} height={14} />
        ))}
      </Box>
      {Array.from({ length: rows }).map((__, row) => (
        <Box
          key={row}
          sx={{
            display: "grid",
            gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
            gap: 2,
            px: 2,
            py: 1.75,
            borderTop: `1px solid ${NJIM.border}`,
          }}
        >
          {Array.from({ length: columns }).map((___, col) => (
            <Skeleton key={col} height={16} />
          ))}
        </Box>
      ))}
    </Box>
  );
};

export default TableSkeleton;
